import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  LINKS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/links/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_LINKS: ({ commit, dispatch }, links) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/links`, { links: links }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  PASTE_LINKS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/links/add-from-site`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_LINK: ({ commit, dispatch }, { linkId, link }) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/links/${linkId}`, link).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_LINK: ({ commit, dispatch }, linkId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/links/${linkId}/page-stats`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_LINKS_COUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/links/info `).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_LINKS: ({ commit, dispatch }, linkIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/links/delete`, { link_ids: linkIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  RECHECK_LINK: ({ commit, dispatch }, linkId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/links/${linkId}/recheck`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_LINK_XLSX: ({ commit, dispatch }, linkId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/links/${linkId}/download/xlsx`, {responseType: 'blob'}).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  LINK_LOG: ({ commit, dispatch }, linkId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/links/${linkId}/log`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/link/actions.js